function getColorByCode(colorCode) {
	return aeo['translations']['colors'][colorCode]
}

export { getColorByCode }